<template>
  <div class="tab">
    <h3>调查实施</h3>
    <div>
      <p>中国儿童青少年积极发展调查及促进研究（CPYDS）各省调查负责人工作流程示意图如下： </p>
        <img src="../../assets/process.png" alt="">
        <p>中国儿童青少年积极发展调查及促进研究（CPYDS）问卷施测过程包括以下六大步骤：</p>
        <img src="../../assets/process1.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'process',
  data () {
    return {}
  }
}
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>
<style scoped>
  .tab>div>img{
    margin-bottom: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/components/tabs/process.vue